<template>
  <div>
    <el-row>
      <el-button
        @click="back()"
        style="width: 10%; float: left; color: white; cursor: pointer"
      >返回稿件列表
      </el-button
      >
      <el-button
        style="width: 10%; float: right; color: white"
        @click="cancelTheAudit()"
      >撤销送审
      </el-button
      >
    </el-row>
    <el-row>
      <el-col class="content">
        <div class="mydoc">
          <div class="header" style="font-weight: 900"><i></i>稿件信息</div>
          <div class="mybody" v-if="manuscripts.newest != null">
            <el-descriptions border :column="1">
              <el-descriptions-item label="稿件标题">{{
                  manuscripts.newest.manuscript.title
                }}
              </el-descriptions-item>
              <el-descriptions-item label="稿件编号"
              >SYYYX-{{ time }}
              </el-descriptions-item
              >
              <el-descriptions-item label="作者信息">
                <span
                  v-for="(item, index) in manuscripts.newest.manuscript
                    .authorInfo"
                  :key="index"
                >
                  {{
                    item.name +
                    "  [" +
                    "联系电话：" +
                    item.phone +
                    "," +
                    "邮箱：" +
                    item.email +
                    "," +
                    "所属单位：" +
                    item.unit +
                    "]"
                  }}
                  <br/>
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="摘要">
                <p>
                  {{ manuscripts.newest.manuscript.abstracts }}
                </p></el-descriptions-item
              >
              <el-descriptions-item label="关键词：">
                {{ manuscripts.newest.manuscript.manuscriptKeywords }}
              </el-descriptions-item>
              <el-descriptions-item label="下载">
                <el-button
                  type="primary"
                  @click="downloadZip(getZipUrl(manuscripts.newest.manuscript))"
                  style="background-color: #fd7f48"
                >下载
                </el-button
                >
                <el-button
                  type="primary"
                  @click="contentShow = true"
                  style="margin-left: 10px; background-color: #fd7f48"
                >点击预览
                </el-button
                >
                <el-dialog
                  :title="manuscripts.newest.manuscript.title"
                  :visible.sync="contentShow"
                  fullscreen
                >
                  <div style="height: 85vh; width: 100%">
                    <iframe
                      :src="
                        'https://www.exp-linguistics.net/file_preview/onlinePreview?url=' +
                        getPdfBase64(manuscripts.newest.manuscript)
                      "
                      frameborder="none"
                      width="100%"
                      height="100%"
                    ></iframe>
                  </div>
                </el-dialog>
              </el-descriptions-item>
              <el-descriptions-item label="提交日期">
                {{ manuscripts.newest.manuscript.deliveryTime.substr(0, 10) }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </el-col>
    </el-row>
    <br/>
    <br/>

    <div v-if="chargeManuscriptStatus == 'unreviewed'">
      <el-row class="content">
        <div class="mydoc">
          <div class="header" style="font-weight: 900">选择审稿人</div>
          <div class="mybody">
            <el-col :span="10">
              <el-input placeholder="请搜索审稿人" v-model="search.name">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="reviewerList()"
                >搜索
                </el-button
                >
              </el-input>
              &nbsp;
              <el-table
                ref="roleTable"
                height="250"
                border
                size="mini"
                tooltip-effect="dark"
                width="100%"
                :data="roleList"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="email" label="邮箱"></el-table-column>
                <el-table-column label="来源">
                  <template slot-scope="scope">
                    <el-tag
                      type="success"
                      v-if="scope.row.type == '推荐审稿人'"
                    >{{ scope.row.type }}
                    </el-tag
                    >
                    <el-tag v-else-if="scope.row.type == '审稿人'">{{
                        scope.row.type
                      }}
                    </el-tag>
                    <el-tag type="danger" v-else>{{ scope.row.type }}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </el-col
            >
            <el-col :span="4">
              <el-tooltip
                content="点击选中转发审稿人"
                placement="bottom"
                effect="light"
              >
                <el-button
                  @click.native="selectedRole"
                  type="primary"
                  style="
                    width: 100%;
                    height: 40px;
                    margin-top: 120px;
                    background-color: #fd7f48;
                  "
                >点击选中转发审稿人
                </el-button
                >
              </el-tooltip>
            </el-col>
            <el-col :span="10">
              <el-table
                height="250"
                border
                :data="forwardList"
                ref="forwardTable"
                width="100%"
                size="mini"
                tooltip-effect="dark"
              >
                <el-table-column fixed prop="name" label="姓名">
                </el-table-column>

                <el-table-column fixed prop="email" label="邮件">
                </el-table-column>

                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="
                        deleteRow(scope.$index, forwardList)
                      "
                      type="text"
                      style="width: 120px; color: white"
                      size="medium"
                    >
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </div>
        </div>
      </el-row>
      <br/>
      <br/>
      <el-row class="content">
        <div class="mydoc">
          <div class="header" style="font-weight: 900">审稿意见</div>
          <div class="mybody">
            <el-form ref="manuscripts" label-width="100px">
              <el-form-item label="审批意见" prop="title">
                <el-input
                  v-model="manuscripts.newest.charge.auditOpinion"
                  placeholder="请输入审批意见"
                  type="textarea"
                  :rows="5"
                  size="medium"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="是否送审"
                prop="manuscripts.newest.charge.manuscriptStatus"
              >
                <el-select
                  v-model="manuscripts.newest.charge.manuscriptStatus"
                  placeholder="请选择是否送审"
                  size="medium"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(selectItem, key) in options"
                    :key="key"
                    :label="selectItem.label"
                    :value="selectItem.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>

            <el-button
              type="primary"
              style="float: right"
              @click.native="submit(manuscripts.newest.charge)"
            >提交
            </el-button
            >
          </div>
        </div>
      </el-row>
    </div>
    <div v-else>
      <el-col class="content">
        <div class="mydoc">
          <div class="header" style="font-weight: 900"><i></i>审核信息</div>
          <div class="mybody">
            <div v-if="chargeManuscriptStatus != 'unreviewed'">
              <el-col :span="24">
                <br/>
                <el-divider content-position="center"
                ><h2>责任编辑评审</h2></el-divider
                >

                <el-col v-if="chargeManuscriptStatus == 'refuse'">
                  <el-alert type="warning" :closable="false">
                    责任编辑初审状态: 已驳回
                  </el-alert>
                  <el-descriptions border :column="1">
                    <el-descriptions-item label="审核意见">{{
                        manuscripts.newest.charge.auditOpinion
                      }}
                    </el-descriptions-item>
                    <el-descriptions-item label="审核日期">
                      {{
                        manuscripts.newest.charge.modificationTime
                      }}
                    </el-descriptions-item
                    >
                  </el-descriptions>
                </el-col>
                <el-col v-else>
                  <el-alert type="success" :closable="false">
                    责任编辑初审状态: 已送审
                  </el-alert>
                  <el-descriptions border :column="1">
                    <el-descriptions-item label="审核意见">{{
                        manuscripts.newest.charge.auditOpinion
                      }}
                    </el-descriptions-item>
                    <el-descriptions-item label="审核日期">
                      {{
                        manuscripts.newest.charge.modificationTime
                      }}
                    </el-descriptions-item
                    >
                  </el-descriptions>
                  <br/>
                  <br/>
                </el-col>
              </el-col>
            </div>

            <div
              v-if="
                (chargeManuscriptStatus != 'unreviewed' &&
                  chargeManuscriptStatus != refuse) ||
                chargeManuscriptStatus == 'second_refuse'
              "
            >
              <el-col :span="24">
                <el-col
                  v-for="(item, index) in manuscripts.newest.reviewers"
                  :key="index"
                >
                  <el-divider content-position="center"
                  ><h2>审稿人评审</h2></el-divider
                  >
                  <br/>
                  <br/>
                  <template>
                    <el-alert type="info" :closable="false">
                      审稿人审核状态:
                      <el-tag
                        v-if="item.manuscriptStatus == 'unreviewed'"
                        type="warning"
                      >未审核
                      </el-tag
                      >
                      <el-tag
                        v-else-if="item.manuscriptStatus == 'success'"
                        type="success"
                      >通过
                      </el-tag
                      >
                      <el-tag v-else type="error">驳回</el-tag>
                    </el-alert>
                    <el-descriptions border :column="3">
                      <el-descriptions-item label="审稿人姓名" :span="2">
                        {{ item.name }}
                      </el-descriptions-item>
                      <el-descriptions-item label="是否展示给作者" :span="1">
                        <el-switch
                          v-model="item.visible"
                          active-color="#F08347"
                          inactive-color="#1B4847"
                          active-text="展示"
                          inactive-text="隐藏"
                          active-value="show"
                          inactive-value="hidden"
                        >
                        </el-switch>
                      </el-descriptions-item>
                      <el-descriptions-item label="审核意见" :span="3">
                        <p>
                          {{ item.auditOpinion }}
                        </p>
                      </el-descriptions-item>
                      <el-descriptions-item
                        label="给编辑部的意见或建议"
                        :span="3"
                      >
                        {{ item.chargeOpinion }}
                      </el-descriptions-item>
                      <el-descriptions-item label="选题方面">{{
                          item.topicValue
                        }}
                      </el-descriptions-item>
                      <el-descriptions-item label="理论意义">{{
                          item.theoryValue
                        }}
                      </el-descriptions-item>
                      <el-descriptions-item label="应用价值">
                        <p>
                          {{ item.useValue }}
                        </p></el-descriptions-item
                      >
                      <el-descriptions-item label="创新性">
                        {{ item.creativeValue }}
                      </el-descriptions-item>

                      <el-descriptions-item label="分析方法">{{
                          item.analyzeValue
                        }}
                      </el-descriptions-item>
                      <el-descriptions-item label="研究结论">{{
                          item.studyValue
                        }}
                      </el-descriptions-item>
                      <el-descriptions-item label="学术水平">
                        <p>
                          {{ item.academicValue }}
                        </p></el-descriptions-item
                      >
                      <el-descriptions-item label="总体评价">
                        {{ item.aboveValue }}
                      </el-descriptions-item>
                      <el-descriptions-item label="审稿结论：">
                        <el-select
                          disabled
                          v-model="item.manuscriptStatus"
                          placeholder="请选择"
                        >
                          <el-option label="可以发表 " value="success">
                          </el-option>
                          <el-option label="改后发表 " value="fixed_publish">
                          </el-option>
                          <el-option label="改后重审" value="fixed_review">
                          </el-option>
                          <el-option label="不宜发表" value="refuse">
                          </el-option>
                        </el-select>
                      </el-descriptions-item>
                    </el-descriptions>
                  </template>
                </el-col>
              </el-col>
              <br/>
              <br/>
            </div>
            <div
              v-if="
                chargeManuscriptStatus == 'second_unreviewed' ||
                chargeManuscriptStatus == 'second_refuse' ||
                manuscripts.newest.charge.secondAuditOpinion == null
              "
            >
              <el-col>
                <br/>
                <br/>
                <el-divider content-position="center">
                  <h2>责任编辑再审</h2>
                </el-divider>
                <br/>
                <br/>
                <template>
                  <span>&nbsp;审稿意见或修改意见:</span>
                  <el-input
                    style="height: 200px"
                    :rows="8"
                    type="textarea"
                    placeholder="请输入具体审稿意见和修改意见："
                    v-model="manuscripts.newest.charge.secondAuditOpinion"
                    show-word-limit
                  ></el-input>
                  <span>&nbsp;再审意见:</span>
                  <el-select
                    v-model="manuscripts.newest.charge.manuscriptStatus"
                    style="width: 100%"
                    placeholder="请选择"
                  >
                    <el-option label="同意发表" value="success"></el-option>
                    <el-option label="驳回" value="refuse"></el-option>
                  </el-select>
                  <br/>
                  <br/>

                  <el-col :span="4" :offset="20">
                    <el-button type="primary" @click.native="submitSecond()"
                    >提交/修改
                    </el-button
                    >
                  </el-col>
                </template>
              </el-col>
            </div>
            <div v-else>
              <template>
                <el-col
                  v-if="
                    chargeManuscriptStatus == 'seconed_refuse' &&
                    manuscripts.newest.charge.secondAuditOpinion != null
                  "
                >
                  <br/>
                  <br/>
                  <el-divider content-position="center">
                    <h2>责任编辑再审</h2>
                  </el-divider>
                  <br/>
                  <br/>
                  <el-alert type="warning" :closable="false">
                    责任编辑再审状态: 已驳回
                  </el-alert>
                  <el-descriptions border :column="1">
                    <el-descriptions-item label="审稿意见或修改意见">{{
                        manuscripts.newest.charge.secondAuditOpinion
                      }}
                    </el-descriptions-item>
                    <el-descriptions-item label="最终意见">
                      {{
                        manuscripts.newest.charge.manuscriptStatus
                      }}
                    </el-descriptions-item
                    >
                  </el-descriptions>
                  <br/>
                  <br/>
                </el-col>
                <el-col v-if="chargeManuscriptStatus == 'success'">
                  <el-divider content-position="center">
                    <h2>责任编辑再审</h2>
                  </el-divider>
                  <br/>
                  <br/>
                  <el-alert type="success" :closable="false">
                    责任编辑再审状态: 已通过
                  </el-alert>
                  <el-descriptions border :column="1">
                    <el-descriptions-item label="审稿意见或修改意见">{{
                        manuscripts.newest.charge.secondAuditOpinion
                      }}
                    </el-descriptions-item>
                    <el-descriptions-item label="最终意见">
                      {{
                        manuscripts.newest.charge.manuscriptStatus
                      }}
                    </el-descriptions-item
                    >
                  </el-descriptions>
                  <br/>
                  <br/>
                </el-col>
              </template>
            </div>
          </div>
        </div
        >
      </el-col>
    </div>
  </div>
</template>

<script>
import {
  getManuscriptsChargeInfo,
  roleList,
  forwardManuscript,
  finalSubmit,
  editorCancelTheAudit
} from '@/api/data'

export default {
  name: 'editorDetail',
  components: {},
  data() {
    return {
      time: null,
      flag: 0,
      chargeManuscriptStatus: null,

      search: {name: ''},
      searchReviewer: null,
      roleList: [],
      forwardList: [],
      selectionRole: [],
      checked: false,
      historyShow: false,
      contentShow: false,
      options: [
        {
          value: 'second_unreviewed',
          label: '送审'
        },
        {
          value: 'refuse',
          label: '不送审'
        }
      ],
      manuscriptsFlag: '',
      manuscripts: {},
      recommends: [
        {
          email: '',
          name: '',
          country: '',
          unit: '',
          phone: '',
          checked: false
        }
      ]
    }
  },
  methods: {
    formatDate(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          )
        }
      }
      return fmt
    },
    // 左边补0函数
    padLeftZero(str) {
      return ('00' + str).substr(str.length)
    },
    cancelTheAudit() {
      editorCancelTheAudit({
        flag: this.manuscriptsFlag
      }).then((res) => {
        console.log('kakaka' + res.data.result)
        if (res.data.result == true) {
          this.$message({
            message: '审核撤销成功',
            type: 'sussess'
          })
          const back = this
          back.$router.push({name: 'editorList'})
          this.fetchInfo()
        }
        this.$message({
          message: '撤销失败',
          type: 'error'
        })
      })
    },

    submitSecond() {
      finalSubmit(this.manuscripts.newest).then((res) => {
        this.fetchManuscriptChargeInfo()
        const back = this
        back.$router.push({name: 'editorList'})
      })
    },
    submit(item) {
      console.log('forwardList=========(submit)', this.forwardList)
      console.log('item+' + item.manuscriptStatus)
      let tempList = []
      if (item.manuscriptStatus != 'refuse') {
        if (this.forwardList.length <= 0) {
          alert('请至少选择一个审稿人')
          return false
        } else {
          for (let i = 0; i < this.forwardList.length; i++) {
            tempList.push({
              id: this.forwardList[i].id,
              reviewerEmail: this.forwardList[i].email,
              name: this.forwardList[i].name,
              country: this.forwardList[i].country,
              unit: this.forwardList[i].unit,
              phone: this.forwardList[i].phone
            })
          }
          console.log('tempList===========', tempList)
          let submitObj = {manuscriptCharge: item}

          for (let i = 0; i < tempList.length; i++) {
            tempList[i].id = JSON.stringify(tempList[i].id)
          }
          console.log(tempList, 77777777777)
          submitObj.reviewerManuscripts = tempList
          console.log('submitObj===========', submitObj)
          forwardManuscript(submitObj).then((res) => {
            const back = this
            back.$router.push({name: 'editorList'})
            this.fetchManuscriptChargeInfo()
          })
        }
      } else {
        let submitObj = {manuscriptCharge: item}
        forwardManuscript(submitObj).then((res) => {
          const back = this
          back.$router.push({name: 'editorList'})
          this.fetchManuscriptChargeInfo()
        })
      }
    },
    deleteRow(index, rows) {
      this.forwardList.splice(index, 1)
    },
    handleSelectionChange(selection) {
      this.selectionRole = selection
    },
    selectedRole() {
      this.forwardList = this.selectionRole
      console.log('selectionRole(submit)==========', this.selectionRole)
    },
    back() {
      const back = this
      back.$router.push({name: 'editorList'})
    },
    reviewerList() {
      roleList({
        type: '审稿人',
        name: this.search.name
      }).then((res) => {
        console.log(res.data, 1111111111111)
        this.roleList = res.data.result
        let tmpRoleList = []
        // let tmpReviewers = (
        //   this.manuscripts.newest.manuscript.recommendAvoidReviewers
        // );
        // let recommends = tmpReviewers.recommends;
        // let avoids = tmpReviewers.avoids;
        // let normal = res.data.result;
        // for (let index in recommends) {
        //   recommends[index].type = "推荐审稿人";
        //   tmpRoleList.push(recommends[index]);
        // }
        // for (let index in normal) {
        //   normal[index].type = "审稿人";
        //   tmpRoleList.push(normal[index]);
        // }
        // for (let index in avoids) {
        //   avoids[index].type = "回避审稿人";
        //   tmpRoleList.push(avoids[index]);
        // }
        // this.roleList = tmpRoleList;
      })
    },
    fetchManuscriptChargeInfo() {
      getManuscriptsChargeInfo({
        manuscriptFlag: this.manuscriptsFlag
      }).then((res) => {
        this.manuscripts = res.data.result
        this.manuscripts.newest.manuscript.authorInfo = this.manuscripts.newest.manuscript.authorInfo.filter(item => item !== null)
        console.log(this.manuscripts, 'this.manuscripts')
        let date = new Date(
          this.manuscripts.newest.manuscript.manuscriptId / 1000
        )
        this.time = this.formatDate(date, 'yyyy-MM-dd hh:mm:ss')

        this.chargeManuscriptStatus =
          this.manuscripts.newest.charge.manuscriptStatus
        this.manuscripts.newest.charge.manuscriptStatus =
          this.manuscripts.newest.charge.manuscriptStatus

        this.reviewerList()
      })
    },
    getPdfBase64(item) {
      return Base64.encode(
        'http://www.exp-linguistics.net/file/' +
        JSON.parse(item.content).mainPdf
      )
    },
    getZipUrl(item) {
      return (
        'http://www.exp-linguistics.net/file/' + item.title + item.manuscriptId + '.zip'
      )
    },
    downloadZip(fileUrl) {
      window.open(fileUrl)
    }
  },
  mounted() {
    this.manuscriptsFlag = this.$route.query.flag
    this.fetchManuscriptChargeInfo()
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 12px;

  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;

    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);

      padding: 10px;
      background-color: white;
      overflow: auto;
    }

    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}

.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}

button {
  background-color: #004947;
  border: none;
}

button:hover {
  background-color: #004947;
}

button:active {
  background-color: #004947;
}
</style>



// WEBPACK FOOTER //
// src/view/editor/editorDetail.vue